import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './agsachbearbeiter.module.scss';

export default function     AgSachbearbeiterDashboard() {

    //const dispatch = useDispatch<AppDispatch>();
    //const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
    }, []);

    return (
        <>
            <div className="container">

                <h3>Office Team</h3>

                <div className={styles.cardContainer} style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 3fr))", gap: "20px", marginTop: "20px" }}>

                    <div className={"card " + styles.landingPageCard} onClick={() => navigate("./agsachbearbeiter/auftragsliste")}>
                        <span className={styles.landingPageCardSpan}>
                            Liste Aufträge
                        </span>
                    </div>

                </div>

            </div>  

        </>
    );
}
